module.exports = __webpack_public_path__ + "static/600x550-orlencharge-termin3-94742d5ed7e51de6401968ef168681d6.jpg";